import * as React from 'react'

const SvgPhotoIcon = (props) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.66699 6.98104C1.66699 6.68911 1.66699 6.54314 1.67917 6.4202C1.79666 5.23441 2.73472 4.29635 3.9205 4.17887C4.04345 4.16669 4.19729 4.16669 4.50498 4.16669C4.62354 4.16669 4.68282 4.16669 4.73315 4.16364C5.37583 4.12472 5.93862 3.71908 6.17878 3.12169C6.19759 3.0749 6.21517 3.02216 6.25033 2.91669C6.28548 2.81121 6.30306 2.75847 6.32187 2.71169C6.56203 2.11429 7.12482 1.70866 7.7675 1.66974C7.81784 1.66669 7.87343 1.66669 7.98461 1.66669H12.016C12.1272 1.66669 12.1828 1.66669 12.2331 1.66974C12.8758 1.70866 13.4386 2.11429 13.6788 2.71169C13.6976 2.75847 13.7152 2.81121 13.7503 2.91669C13.7855 3.02216 13.8031 3.0749 13.8219 3.12169C14.062 3.71908 14.6248 4.12472 15.2675 4.16364C15.3178 4.16669 15.3771 4.16669 15.4957 4.16669C15.8034 4.16669 15.9572 4.16669 16.0802 4.17887C17.2659 4.29635 18.204 5.23441 18.3215 6.4202C18.3337 6.54314 18.3337 6.68911 18.3337 6.98104V13.5C18.3337 14.9002 18.3337 15.6002 18.0612 16.135C17.8215 16.6054 17.439 16.9879 16.9686 17.2275C16.4339 17.5 15.7338 17.5 14.3337 17.5H5.66699C4.26686 17.5 3.5668 17.5 3.03202 17.2275C2.56161 16.9879 2.17916 16.6054 1.93948 16.135C1.66699 15.6002 1.66699 14.9002 1.66699 13.5V6.98104Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0003 13.75C11.8413 13.75 13.3337 12.2576 13.3337 10.4167C13.3337 8.57574 11.8413 7.08335 10.0003 7.08335C8.15938 7.08335 6.66699 8.57574 6.66699 10.4167C6.66699 12.2576 8.15938 13.75 10.0003 13.75Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgPhotoIcon
